import { render, staticRenderFns } from "./SubmissionSignatureButton.vue?vue&type=template&id=2ed551a4&"
import script from "./SubmissionSignatureButton.vue?vue&type=script&lang=js&"
export * from "./SubmissionSignatureButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports